(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  const SLIDES_PER_SECOND = 1.65;
  const FOLLOW = 0.2;
  const running = new Set();
  const states = new WeakMap();
  let raf = 0;

  const hydrate = (track) => {
    if (!track || track.dataset.hydrated === 'true') return;
    track.dataset.hydrated = 'true';
    track.querySelectorAll('img[data-src]').forEach((img) => {
      const src = img.getAttribute('data-src');
      const srcset = img.getAttribute('data-srcset');
      if (src) img.src = src;
      if (srcset) img.srcset = srcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  };

  const getState = (root) => {
    let state = states.get(root);
    if (!state) {
      state = {
        root,
        track: root.querySelector('[data-bagveda-card-track]'),
        slides: Number(root.dataset.slides) || 0,
        current: 0,
        target: 0,
        auto: 0,
        dir: 1,
        lastTs: 0,
        hovering: false,
      };
      states.set(root, state);
    }
    return state;
  };

  const apply = (state) => {
    state.track.style.transform = 'translate3d(' + -state.current * 100 + '%,0,0)';
  };

  const tick = (ts) => {
    running.forEach((state) => {
      if (!state.lastTs) state.lastTs = ts;
      const dt = Math.min(0.048, (ts - state.lastTs) / 1000);
      state.lastTs = ts;

      const max = Math.max(0, state.slides - 1);

      if (state.hovering && max > 0) {
        state.auto += state.dir * SLIDES_PER_SECOND * dt;
        if (state.auto >= max) {
          state.auto = max;
          state.dir = -1;
        } else if (state.auto <= 0) {
          state.auto = 0;
          state.dir = 1;
        }
        state.target = state.auto;
      } else {
        state.target = 0;
        state.auto = 0;
        state.dir = 1;
      }

      state.current += (state.target - state.current) * (state.hovering ? FOLLOW : 0.24);
      if (Math.abs(state.target - state.current) < 0.0015) state.current = state.target;
      apply(state);

      if (!state.hovering && state.current === 0) {
        state.track.style.willChange = '';
        state.lastTs = 0;
        running.delete(state);
      }
    });

    raf = running.size ? requestAnimationFrame(tick) : 0;
  };

  const start = (state) => {
    if (!state.track || state.slides < 2) return;
    state.track.style.willChange = 'transform';
    running.add(state);
    if (!raf) raf = requestAnimationFrame(tick);
  };

  const enterRoot = (root) => {
    if (!root || Number(root.dataset.slides) < 2) return;
    const state = getState(root);
    hydrate(state.track);
    state.hovering = true;
    state.lastTs = 0;
    start(state);
  };

  const leaveRoot = (root) => {
    if (!root) return;
    const state = states.get(root);
    if (!state) return;
    state.hovering = false;
    start(state);
  };

  const CARD_SELECTOR = '.bagveda-product-card, .bagveda-mjft-tile';

  document.addEventListener(
    'pointerover',
    (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      const card = event.target.closest(CARD_SELECTOR);
      if (!card) return;
      const fromCard =
        event.relatedTarget && event.relatedTarget.closest
          ? event.relatedTarget.closest(CARD_SELECTOR)
          : null;
      if (fromCard === card) return;
      enterRoot(card.querySelector('[data-bagveda-card-hover]'));
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      const card = event.target.closest(CARD_SELECTOR);
      if (!card) return;
      const toCard =
        event.relatedTarget && event.relatedTarget.closest
          ? event.relatedTarget.closest(CARD_SELECTOR)
          : null;
      if (toCard === card) return;
      leaveRoot(card.querySelector('[data-bagveda-card-hover]'));
    },
    { passive: true }
  );
})();
